
import { css } from 'lit';
export default css`
/* See https://github.com/tailwindlabs/tailwindcss-aspect-ratio/blob/master/src/index.js */

.video--youtube {
  /*@apply relative block h-0;*/
  /*padding-bottom: calc(9 / 16 * 100%);*/
}

.video--youtube iframe {

  position: absolute;

  top: 0px;

  bottom: 0px;

  left: 0px;

  right: 0px;

  display: block;

  height: 100%;

  width: 100%
}
`;